<script>
export default {
  name: "SelectUI",
  props: {
    options: Array,
    customWidth: {
      type: String,
      default: '377px'
    }
    
  },
  methods: {
    toggleSort(event) {
      let mobile = window.innerWidth < 1024;
      if (mobile) {
        let parent = event.currentTarget;
        let sortText = parent.querySelector(".selectUi__text");
        let sortRating = parent.querySelector(".selectUi__rating");

        sortText.classList.toggle("active");
        sortRating.classList.toggle("active");
      } else {
        return;
      }
    },
    enterSort(event) {
      let parent = event.currentTarget;
      let sortText = parent.querySelector(".selectUi__text");
      let sortRating = parent.querySelector(".selectUi__rating");

      sortText.classList.add("active");
      sortRating.classList.add("active");
    },
    leaveSort(event) {
      let parent = event.currentTarget;
      let sortText = parent.querySelector(".selectUi__text");
      let sortRating = parent.querySelector(".selectUi__rating");

      sortText.classList.remove("active");
      sortRating.classList.remove("active");
    },
    sortItem(event) {
      let parent = event.currentTarget;
      let dataSortTheme = parent.getAttribute("data-sorttheme");
      let fam = parent.closest(".selectUi");
      fam.querySelector(".selectUi__text span").textContent =
        parent.textContent;
        
        for( let o of this.options){
         
          if(o.name == dataSortTheme){
            this.$emit("sort", o);
          }
        }

    },
  },
};
</script>
<template>
  <div
    class="selectUi"
    :style="{ width: customWidth }"
    @mouseover="enterSort"
    @mouseleave="leaveSort"
    @click="toggleSort"
  >
    <div class="selectUi__text">
      <span>{{ options[0].name }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16 10L12 14L8 10"
          stroke="#1E1F22"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="selectUi__rating">
      <div
        v-for="option in options"
        :key="option.id"
        class="selectUi__rating-item"
        @click="sortItem"
        :data-sorttheme="option.name"
      >
        {{ option.name }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.selectUi {
  position: relative;
  
  width: 377px;
  max-width: 100%;
  padding: 19px 20px;
  border-radius: 15px;
  border: 1px solid #d4dbde;
  background: #fff;
  cursor: pointer;
}
.selectUi__period .selectUi__text{
  color: #fff;
}
.selectUi__period .selectUi__text path {
  stroke: #fff;
}
.selectUi__text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}
.selectUi__rating {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 19px;
  border: 1px solid #d9d9d9;
  background: #fff;
  padding: 15px;
  z-index: 6;
  margin: 0;
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  border-radius: 15px;
}
.selectUi__rating.active {
  opacity: 1;
  visibility: visible;
  transition: all 0.3s;
}
.selectUi svg {
  transition: all 0.3s;
}
.selectUi:has(.selectUi__rating.active) svg {
  transform: rotate(180deg);
}
</style>